import React from "react";
import { AdminTabs } from "@/components/AdminTabs";
import { SecurityPanel } from "@/components/SecurityPanel";
import { useAuth } from "@/contexts/AuthContext";
import { UserCog } from "lucide-react";
import { AdminAlertSettings } from "@/components/admin/AdminAlertSettings";

export default function AdminAccount() {
  const { user } = useAuth();
  return (
    <div className="container-x py-12" data-testid="admin-account-page">
      <AdminTabs />
      <h1 className="font-heading text-3xl text-[#1E3F33] font-semibold mb-1 flex items-center gap-2">
        <UserCog className="w-7 h-7 text-[#2D6A4F]" /> My account
      </h1>
      <p className="text-sm text-[#5C6B64] mb-6">Signed in as <span className="font-medium text-[#1E3F33]">{user?.username}</span> · change your admin username, password and alert settings.</p>
      <div className="grid lg:grid-cols-2 gap-6 items-start">
        <div className="max-w-md w-full">
          <SecurityPanel />
        </div>
        <AdminAlertSettings />
      </div>
    </div>
  );
}
